import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { translate } from "app/filters/i18nFilter";
import { renderIndustryDataAvailabilityNotice } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/IndustryDataAvailabilityBanner";
import { useDurationSubtitleFilter } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDurationSubtitleFilter";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";

import { DisplayAdvertisingFormatBreakdownWidget } from "../../DisplayAdvertisingFormatBreakdownWidget";
import type { IFormatShare } from "../../hooks/useFormatBreakdown";
import { useIndustryFormatBreakdown } from "./useIndustryFormatBreakdown";

const EMPTY_FORMAT_SHARE: IFormatShare = { video: 0, banner: 0, native: 0 };

interface IIndustryFormatBreakdownProps {
    category: IFlattenedCategory;
}

export const IndustryFormatBreakdown = ({ category }: IIndustryFormatBreakdownProps) => {
    const { data, isLoading, isError, availability } = useIndustryFormatBreakdown(category);
    const durationSubtitleFilter = useDurationSubtitleFilter(data?.startDate);

    const showFormatBreakdownEmptyState = !isLoading && (!data || isError);

    return (
        <WidgetContainer
            title={translate("ad.intelligence.overview.format.breakdown.widget.title")}
            tooltip={translate("ad.intelligence.overview.format.breakdown.widget.title.tooltip")}
            subtitleFilters={[durationSubtitleFilter]}
            height="100%"
            isLoading={isLoading}
            loaderWidth="100%"
            showSubtitleFiltersLoadingState={false}
            loaderHeight={98}
            automationId="industry-format-breakdown-widget"
            noticeSlot={renderIndustryDataAvailabilityNotice(availability)}
        >
            <DisplayAdvertisingFormatBreakdownWidget
                spendShare={data?.spendShare ?? EMPTY_FORMAT_SHARE}
                impressionsShare={data?.impressionsShare ?? EMPTY_FORMAT_SHARE}
                visitsShare={data?.visitsShare ?? EMPTY_FORMAT_SHARE}
                showEmptyState={showFormatBreakdownEmptyState}
                hasError={isError}
            />
        </WidgetContainer>
    );
};
